import type { Permission } from '@ztechapps/common.contract'

export const projectPermissions = {
  canView: {
    value: 'project.canView',
    label: 'Can View',
    description: 'No modification can be done to the project, only viewing of details.',
  } satisfies Permission,
  canEdit: {
    value: 'project.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of project',
  } satisfies Permission,
  canDelete: {
    value: 'project.canDelete',
    label: 'Can Delete',
    description:
      'Can delete the records for all fields of project. This will delete entire record and cannot be recovered.',
  } satisfies Permission,
}
